import { ChevronLeftIcon, ChevronRightIcon } from "@heroicons/react/24/outline";
import { CarouselProvider, Slide, Slider, DotGroup, ButtonBack, ButtonNext } from "pure-react-carousel";
import "./carousel.css";


interface CarouselProps {
    // elements: React.ReactNode[];
    elements: string[];
    width: number;
    height: number;
}

const Carousel: React.FC<CarouselProps> = ({ elements, width, height }) => {
    // const [currentElement, setCurrentElement] = useState(0);

    return (
        <CarouselProvider
            naturalSlideWidth={width || 100}
            naturalSlideHeight={height || 100}
            totalSlides={elements.length}
            infinite={true}
        >
            <div className="container">
                <Slider>
                    {elements.map((element, index) =>
                        <Slide index={index} >
                            <div 
                            style={{width: '100%', height: '100%'}}
                            className="flex items-center justify-center"
                            dangerouslySetInnerHTML={{ __html: element }} />
                        </Slide>
                    )}
                </Slider>
                <ButtonBack className="buttonBack">
                    <ChevronLeftIcon className="h-6 w-6" />
                </ButtonBack>
                <ButtonNext className="buttonNext">
                    <ChevronRightIcon className="h-6 w-6" />
                </ButtonNext>
                <div>
                    <DotGroup
                        className="flex flex-row justify-center mt-2"
                        renderDots=
                        {({ currentSlide, totalSlides }) => (
                            Array.from({ length: totalSlides ?? 0 }).map((_, index) => (
                                <div
                                    key={index}
                                    className={`w-2 h-2 rounded-full mx-1 ${currentSlide === index ? 'bg-gray-800' : 'bg-gray-400'}`}
                                />
                            ))
                        )}
                    />
                </div>
            </div>
        </CarouselProvider>
    );
};
export default Carousel;
